import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { _ } from 'utils'
import { EventType, UpdateEventInput } from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import constants from 'constants/constants'
import NumberField from 'features/forms/components/NumberField'

const SuperAdmin = () => {
    const formContext = useFormikContext()
    const values = formContext.values as UpdateEventInput & EventType
    const total = values.maxDurationInDays
    const remaining = values.openedDaysLeft
    const usedDays = total - remaining
    const totalBooths = getNodes(values.spaces).filter((e) => e.type === 'booth').length
    const totalSpaces = values.spaces?.totalCount - totalBooths
    const isLite = constants.isLite
    const availableNetworkingDays = isLite
        ? remaining
        : values.networkingDaysLeft

    useEffect(() => {
        if (
            isLite
            && values.resellerConfig.maxDurationInDays !== values.resellerConfig.maxDaysWithNetworking
        ) {
            formContext.setFieldValue(
                'resellerConfig.maxDaysWithNetworking',
                values.resellerConfig.maxDurationInDays
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLite, values.maxDaysWithNetworking, values.maxDurationInDays])

    return (
        <>
            <NumberField
                name="resellerConfig.maxSpaces"
                label={_('generalsettings.form.max_spaces')}
                helperText={_('generalsettings.form.spaces_are_used', {
                    value: totalSpaces,
                    available: values.resellerConfig.maxSpaces - totalSpaces,
                })}
                isDisabled={isLite}
            />
            <NumberField
                name="resellerConfig.maxDurationInDays"
                label={_('generalsettings.form.max_duration_in_days')}
                lg={1 / 2}
                helperText={_('generalsettings.form.days_are_used', {
                    value: usedDays,
                    available: remaining,
                })}
                isDisabled={isLite}
            />
            <NumberField
                name="resellerConfig.maxDaysWithNetworking"
                label={_('generalsettings.form.max_days_with_networking')}
                lg={1 / 2}
                helperText={_('generalsettings.form.days_are_used', {
                    value: values.resellerConfig.maxDaysWithNetworking - values.networkingDaysLeft,
                    available: availableNetworkingDays,
                })}
                isDisabled={isLite}
            />
            <NumberField
                name="resellerConfig.maxBooths"
                label={_('generalsettings.form.max_booths')}
                lg={1 / 2}
                helperText={_('generalsettings.form.booths_are_used', {
                    value: totalBooths,
                    available: values.resellerConfig.maxBooths - totalBooths,
                })}
                isDisabled={isLite}
            />
            <NumberField
                name="resellerConfig.maxParticipants"
                label={_('generalsettings.form.max_participants')}
                lg={1 / 2}
                helperText={_('generalsettings.form.participants_are_used', {
                    value: values?.amountOfParticipants,
                    available: values.resellerConfig.maxParticipants - values?.amountOfParticipants,
                })}
                isDisabled={isLite}
            />
        </>
    )
}

export default SuperAdmin
